import I18n from 'i18n-js'
import h from 'hyperscript'
import QueryParams from '@waze/george/lib/query-params'

const MODES = {
  e: 'error',
  w: 'warning',
  i: 'info',
  s: 'success'
}

export function showFlash(mode, message) {
  const bodyEl = h(
    '.wz-flash__body',
    h('button.wz-flash__button', 'X'),
    h('.wz-flash__message', message)
  )

  const flashEl = h('div', { className: `wz-flash wz-flash--${mode}` }, bodyEl)
  flashEl.querySelector('button').addEventListener('click', () => flashEl.remove())

  document.body.appendChild(flashEl)
}

export function loadFlashFromQueryParam() {
  if (!QueryParams.has('flash')) return

  const [mode, key] = QueryParams.get('flash').split('|')
  const message = I18n.t(key, {
    scope: 'flash_messages',
    defaultValue: I18n.t('flash_messages.unexpected')
  })

  showFlash(MODES[mode] || 'error', message)
}
